"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[659],{

/***/ 20659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44012);
/* harmony import */ var api_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9041);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96781);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2185);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


 // import Link from "next/link";




 // import FtafatModal from "components/homePage/goodMorning/ftafatModal";

var FtafatModal = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1818), __webpack_require__.e(9778), __webpack_require__.e(872)]).then(__webpack_require__.bind(__webpack_require__, 29778));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(29778)];
    }
  }
});
 // import BottomStripIPL from "components/cricket/ipl/BottomStripIPL";

var BottomStripIPL = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4044), __webpack_require__.e(8060)]).then(__webpack_require__.bind(__webpack_require__, 28060));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(28060)];
    }
  }
});
 // import ClevertapReact from "utils/clevertapHelper";





var MobileMenuBottom = function MobileMenuBottom() {
  var _router$query, _bottomBanner$, _bottomBanner$3;

  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_4__/* .useWindowSize */ .iP)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isKeyPresent = _useState[0],
      setIsKeyPresent = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isKeyPresentIPL = _useState2[0],
      setIsKeyPresentIPL = _useState2[1];

  var keyToCheck = "RECENGINE"; // The key you want to check

  var keyToCheckIPL = "IPL_STRIP"; // The key you want to check

  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function (_ref) {
    var SeriesReducer = _ref.SeriesReducer;
    return SeriesReducer;
  }),
      videoIsShow = _useSelector.videoIsShow;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(router !== null && router !== void 0 && router.pathname.includes("/quiz") ? "quiz" : router !== null && router !== void 0 && router.pathname.includes("/short-video") ? "short-video" : router !== null && router !== void 0 && router.pathname.includes("/text") ? "text" : router !== null && router !== void 0 && router.pathname.includes("/audio") ? "audio" : router !== null && router !== void 0 && router.pathname.includes("/show") ? "show" : "all"),
      activeTab = _useState3[0],
      setActiveTab = _useState3[1];

  var openFatafat = router.query.fatafat;

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      fatafatPosts = _useState4[0],
      setFatafatPosts = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      scrollY = _useState5[0],
      setScrollY = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      bottomBanner = _useState6[0],
      setBottomBanner = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      closeFooterBanner = _useState7[0],
      setCloseFooterBanner = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showLiveAtBottom = _useState8[0],
      setShowLiveAtBottom = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(typeof openFatafat !== "undefined" && openFatafat === "true" ? true : false),
      shouldShow = _useState9[0],
      setShouldShow = _useState9[1];

  var queryIndex = (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.index ? parseInt(router.query.index) : 0;

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      firstScroll = _useState10[0],
      setFirstScroll = _useState10[1];

  function callGtag() {// window.googletag = window.googletag || { cmd: [] };
    // window.dataLayer = window.dataLayer || [];
    // function gtag() {
    //   dataLayer.push(arguments);
    // }
    // gtag("js", new Date());
    // gtag("config", "G-RXRPKR4310");
    // (function (w, d, s, l, i) {
    //   w[l] = w[l] || [];
    //   w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    //   var f = d.getElementsByTagName(s)[0],
    //     j = d.createElement(s),
    //     dl = l != "dataLayer" ? "&l=" + l : "";
    //   j.async = true;
    //   j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    //   f.parentNode.insertBefore(j, f);
    // })(window, document, "script", "dataLayer", "GTM-P9LRV6T");
    // const gtag1 = document.createElement("script");
    // gtag1.setAttribute(
    //   "src",
    //   "https://www.googletagmanager.com/gtag/js?id=UA-203175993-6"
    // );
    // gtag1.setAttribute("async", "true");
    // document.head.appendChild(gtag1);
    // const gtag2 = document.createElement("script");
    // gtag2.setAttribute(
    //   "src",
    //   "https://www.googletagmanager.com/gtag/js?id=G-RXRPKR4310"
    // );
    // gtag2.setAttribute("async", "true");
    // document.head.appendChild(gtag2);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    router !== null && router !== void 0 && router.pathname.includes("/quiz") ? setActiveTab("quiz") : router !== null && router !== void 0 && router.pathname.includes("/short-video") ? "short-video" : router !== null && router !== void 0 && router.pathname.includes("/text") ? setActiveTab("text") : router !== null && router !== void 0 && router.pathname.includes("/audio") ? setActiveTab("audio") : router !== null && router !== void 0 && router.pathname.includes("/show") ? setActiveTab("show") : setActiveTab("all");
  }, [router === null || router === void 0 ? void 0 : router.pathname]);

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      showFooter = _useState11[0],
      setShowFooter = _useState11[1];

  var _useState12 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      scrollDirection = _useState12[0],
      setScrollDirection = _useState12[1]; // useEffect(()=>{
  //   setTimeout(()=>{
  //     setScrollDirection("up")
  //   },4000);
  // })


  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)( /*#__PURE__*/(0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _router$pathname, _router$pathname2;

    var data, amp, dat;
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!(router !== null && router !== void 0 && (_router$pathname = router.pathname) !== null && _router$pathname !== void 0 && _router$pathname.includes("/post/")) && !(router !== null && router !== void 0 && (_router$pathname2 = router.pathname) !== null && _router$pathname2 !== void 0 && _router$pathname2.includes("/video/")))) {
              _context.next = 9;
              break;
            }

            _context.next = 3;
            return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_8__/* .baseUrl */ .FH, "/banner/all?source=WEB&category=floating-footer"));

          case 3:
            data = _context.sent;
            _context.next = 6;
            return data.json();

          case 6:
            amp = _context.sent;
            dat = amp === null || amp === void 0 ? void 0 : amp.result;
            setBottomBanner(dat);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [router === null || router === void 0 ? void 0 : router.pathname]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var _window;

      // console.log("changing scroll");
      setScrollY((_window = window) === null || _window === void 0 ? void 0 : _window.scrollY);
    }; // Add scroll event listener


    window.addEventListener("scroll", handleScroll); // Clean up the event listener on component unmount

    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var lastScrollY = window.pageYOffset;

    var updateScrollDirection = function updateScrollDirection() {
      var scrollY = window.pageYOffset;
      var direction = scrollY > lastScrollY ? "down" : "up";

      if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
        setScrollDirection(direction);
      }

      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener("scroll", updateScrollDirection); // add event listener

    return function () {
      window.removeEventListener("scroll", updateScrollDirection); // clean up
    };
  }, [scrollDirection]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var _router$query2, _router$query2$shortI;

    if (router.pathname.includes("/short-video")) {
      setActiveTab("short-video");
    }

    setShowFooter(router.pathname !== "/login" && router.pathname !== "/vs/header_lt" && router.pathname !== "/adda/schedule" && router.pathname !== "/cricket-page" && router.pathname !== "/preferences" && router.pathname !== "/loading/profile" && !router.pathname.includes("/app-view") && !router.pathname.includes("/liveblog") && !router.pathname.includes("/faq-app") && !router.pathname.includes("/quiz/terms-and-conditions") && !router.pathname.includes("/amp/") && !(router !== null && router !== void 0 && (_router$query2 = router.query) !== null && _router$query2 !== void 0 && (_router$query2$shortI = _router$query2.shortId) !== null && _router$query2$shortI !== void 0 && _router$query2$shortI.length));
  }, [router.pathname]);

  var shortsTabClicked = /*#__PURE__*/function () {
    var _ref3 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var requestOptions;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              requestOptions = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  limit: 1,
                  skip: 1
                })
              };
              _context2.next = 3;
              return fetch("".concat("https://api.thelallantop.com", "/v1/short/list"), requestOptions).then(function (response) {
                return response.json();
              }).then(function (data) {
                var _data$result;

                var result = data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.entities;
                console.log("lalala", result);
                window.location.href = "/short-video/".concat(result[0].postSlug); // router.push(`/short-video/${result[0].postSlug}`);
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function shortsTabClicked() {
      return _ref3.apply(this, arguments);
    };
  }(); // console.log("showfootermob", !router?.query?.shortId?.length);
  //Fatafat Logic


  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    function handleScroll() {
      setFirstScroll(true);
      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll);
  }, []);

  var handleClick = function handleClick() {
    // pushGoogleTabEvent("homepage_fatafat_open", {});
    setShouldShow(false);
    router.push("/"); // setShow((e) => !e);
  };

  var openHandler = function openHandler() {
    if (fatafatPosts && (fatafatPosts === null || fatafatPosts === void 0 ? void 0 : fatafatPosts.length) > 0) {
      var _fatafatPosts$, _fatafatPosts$2, _fatafatPosts$3;

      setShouldShow(true);
      router.push("?fatafat=".concat((_fatafatPosts$ = fatafatPosts[0]) === null || _fatafatPosts$ === void 0 ? void 0 : _fatafatPosts$.postSlug, "&index=0"), "/".concat((_fatafatPosts$2 = fatafatPosts[0]) === null || _fatafatPosts$2 === void 0 ? void 0 : _fatafatPosts$2.categorySlug, "/post/").concat((_fatafatPosts$3 = fatafatPosts[0]) === null || _fatafatPosts$3 === void 0 ? void 0 : _fatafatPosts$3.postSlug), {
        shallow: true
      });
    } else {
      fatafatHandler();
      setShouldShow(true);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    console.log(router === null || router === void 0 ? void 0 : router.pathname);
  }, []);

  var fatafatHandler = function fatafatHandler() {
    fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_8__/* .baseUrl */ .FH, "/post/allFatafat?limit=9&skip=1&type=text")).then(function (res) {
      return res.json();
    }).then(function (d) {
      var _d$result;

      setFatafatPosts(d === null || d === void 0 ? void 0 : (_d$result = d.result) === null || _d$result === void 0 ? void 0 : _d$result.entities);
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (shouldShow) {
      openHandler();
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    // Check if the key exists in the window object
    if (keyToCheck in window) {
      setIsKeyPresent(true);
    } else {
      setIsKeyPresent(false);
    }
  }, [scrollDirection]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (videoIsShow) {
      setActiveTab('show');
    }
  }, [videoIsShow]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [showFooter && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
      children: [scrollY > 170 && (bottomBanner === null || bottomBanner === void 0 ? void 0 : bottomBanner.length) > 0 && !closeFooterBanner && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [(size === null || size === void 0 ? void 0 : size.width) <= 768 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "close-bottom-menu",
          onClick: function onClick(event) {
            event.stopPropagation();
            setCloseFooterBanner(true);
            console.log("erman");
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            children: "X"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
          href: (_bottomBanner$ = bottomBanner[0]) === null || _bottomBanner$ === void 0 ? void 0 : _bottomBanner$.deepLink,
          onClick: function onClick() {
            var _bottomBanner$2;

            ga("create", "G-RXRPKR4310", "auto");
            ga("send", "event", {
              eventCategory: "banner",
              eventAction: "Click",
              eventLabel: "Footer-banner",
              eventValue: "".concat((_bottomBanner$2 = bottomBanner[0]) === null || _bottomBanner$2 === void 0 ? void 0 : _bottomBanner$2.title)
            });
          },
          x: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
            className: "bottom-menu bottom-menu-banner",
            src: (_bottomBanner$3 = bottomBanner[0]) === null || _bottomBanner$3 === void 0 ? void 0 : _bottomBanner$3.bannerImage
          })
        })]
      }), !showLiveAtBottom && !router.pathname.includes("/audio") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "bottom-menu ".concat(scrollDirection === "down" ? "FooterShow" : "FooterAdHide") // style={{ bottom: "60px" }}
        ,
        style: {
          bottom: scrollDirection !== "down" ? "77px" : isKeyPresent ? "123px" : "26px"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center",
              marginBottom: "0rem"
            },
            className: "bg-white",
            children: "Advertisement"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            id: "div-gpt-ad-1701946324333-0",
            style: {
              minWidth: "300px",
              minHeight: "60px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            className: "bg-white",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946324333-0')})"
              }
            })
          })]
        })
      }), (router.pathname.includes("/ipl") || router.pathname === "/") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [showLiveAtBottom && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "bottom-menu ".concat(scrollDirection === "down" ? "FooterShow" : "FooterAdHide") // style={{bottom: "60px" }}
          ,
          style: {
            bottom: scrollDirection !== "down" ? "83px" : isKeyPresent ? "123px" : "101px"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "container-row py-2",
            align: "center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
              style: {
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
                marginBottom: "0rem"
              },
              className: "bg-white",
              children: "Advertisement"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              id: "div-gpt-ad-1701946324333-0",
              style: {
                minWidth: "300px",
                minHeight: "60px",
                display: "block !important",
                alignContent: "center",
                textAlign: "-webkit-center"
              },
              className: "bg-white",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("script", {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                  __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946324333-0')})"
                }
              })
            })]
          })
        }), scrollDirection === "down" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "bottom-menu ".concat(scrollDirection === "down" ? "FooterShow" : "FooterAdHide") // style={{bottom: "60px" }}
          ,
          style: {
            bottom: scrollDirection !== "down" ? "85px" : isKeyPresent ? "114px" : "30px",
            background: "transparent",
            left: "10px"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(BottomStripIPL, {
            setShowLiveAtBottom: setShowLiveAtBottom
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "bottom-menu ".concat(scrollDirection === "down" ? router.pathname.includes("/audio") ? "" : "FooterHide" : "FooterShow"),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("ul", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            className: activeTab === "all" && !shouldShow ? "active" : "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("a", {
              href: "/",
              onClick: function onClick() {
                if (typeof window.ga !== "undefined") {
                  ga("create", "G-RXRPKR4310", "auto");
                  ga("send", "event", {
                    eventCategory: "bottom_menu",
                    eventAction: "Click",
                    eventLabel: "home",
                    eventValue: "https://www.thelallantop.com/"
                  });
                }

                setActiveTab("all");
              },
              children: [activeTab === "all" && !shouldShow ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
                className: "icon-home icon-padding",
                src: "https://static.thelallantop.com/images/post/1742895514831_home-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
                className: "icon-home icon-padding",
                src: "https://static.thelallantop.com/images/post/1742894786610_home-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                  id: "home",
                  defaultMessage: "\u0939\u094B\u092E"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            className: activeTab === "show" && !shouldShow ? "active" : "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("a", {
              href: "/show/all",
              onClick: function onClick() {
                if (typeof window.ga !== "undefined") {
                  ga("create", "G-RXRPKR4310", "auto");
                  ga("send", "event", {
                    eventCategory: "bottom_menu",
                    eventAction: "Click",
                    eventLabel: "shows",
                    eventValue: "https://www.thelallantop.com/show/all"
                  });
                }

                setActiveTab("show");
              },
              children: [activeTab === "show" && !shouldShow ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
                className: "icon-shows icon-padding",
                src: "https://static.thelallantop.com/images/post/1742895590628_video-play-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
                className: "icon-shows icon-padding",
                src: "https://static.thelallantop.com/images/post/1742894865346_video-play-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                  id: "shows",
                  defaultMessage: "\u0936\u094B"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            className: shouldShow ? "active" : "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("a", {
              href: "/?fatafat=true",
              children: [shouldShow ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
                className: "icon-vidos icon-padding",
                src: "https://static.thelallantop.com/images/post/1742905773194_ftafat_(1)-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
                className: "icon-vidos icon-padding",
                src: "https://static.thelallantop.com/images/post/1742905597275_ftafat-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                style: {
                  color: shouldShow ? "#D9368B" : "black"
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                  id: "fatafat",
                  defaultMessage: "\u0926\u0947\u0916\u093F\u090F"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            className: activeTab === "audio" && !shouldShow ? "active" : "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("a", {
              href: "/audio",
              onClick: function onClick() {
                if (typeof window.ga !== "undefined") {
                  ga("create", "G-RXRPKR4310", "auto");
                  ga("send", "event", {
                    eventCategory: "bottom_menu",
                    eventAction: "Click",
                    eventLabel: "audio",
                    eventValue: "https://www.thelallantop.com/audio"
                  });
                }

                setActiveTab("audio");
              },
              children: [activeTab === "audio" && !shouldShow ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
                className: "icon-listen icon-padding",
                src: "https://static.thelallantop.com/images/post/1742895572359_microphone-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
                className: "icon-listen icon-padding",
                src: "https://static.thelallantop.com/images/post/1742894817738_microphone-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                  id: "audios",
                  defaultMessage: "\u0938\u0941\u0928\u093F\u090F"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
            className: activeTab === "short-video" && !shouldShow ? "active" : "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("a", {
              onClick: function onClick() {
                if (typeof window.ga !== "undefined") {
                  ga("create", "G-RXRPKR4310", "auto");
                  ga("send", "event", {
                    eventCategory: "bottom_menu",
                    eventAction: "Click",
                    eventLabel: "shorts",
                    eventValue: "https://www.thelallantop.com/short-video"
                  });
                }

                shortsTabClicked();
              },
              children: [activeTab === "short-video" && !shouldShow ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
                className: "icon-shows icon-padding",
                src: "https://static.thelallantop.com/images/post/1742895612841_3-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
                className: "icon-shows icon-padding",
                src: "https://static.thelallantop.com/images/post/1742894834784_note-2-min.webp",
                width: "20px",
                height: "20px",
                alt: "home"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                  id: "shorts",
                  defaultMessage: "\u0936\u0949\u0930\u094D\u091F\u094D\u0938"
                })
              })]
            })
          })]
        })
      })]
    }), fatafatPosts && fatafatPosts.length > 0 && shouldShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(FtafatModal, {
      show: shouldShow,
      fatafatPosts1: fatafatPosts,
      onClick: function onClick() {
        handleClick();
      },
      queryIndex: queryIndex
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (MobileMenuBottom);

/***/ })

}]);